import { appUrls } from "../../config/api-config/appUrls";
import { post } from "../../config/api-config/callMethods";
import { environment } from "../../config/environments/environment";
import { FeedbackPayload } from "../../components/layout/sidebar/sidebarFeedback.utils";

export function feedbackSave(feedbackAndRatingDto: any) {
  const url = environment.api + appUrls.feedBack.save;
  return post(url, feedbackAndRatingDto);
}
export function talktoSale(talktoSaleDto: any) {
  const url =
    environment.organizationSettingsApi + appUrls.talktoSale.sendMessage;
  return post(url, talktoSaleDto);
}

export function submitFeedbackData(feedbackPayloadData: FeedbackPayload) {
  const url = environment.cmBackendUrl + "/" + appUrls.feedBack.submit;
  return post(url, feedbackPayloadData)
}